import PDFObject from 'pdfobject/pdfobject';

const $ = window.jQuery;

$(document).ready(function() {

    var $node = $("#pdf-content");
    var file = $node.data('pdf');

    if($node) {
        if(PDFObject.supportsPDFs){
            
            var options = {
                height: "calc(100vh - 80px)",
                // pdfOpenParams: { view: 'FitV'},
                toolbar: 0,
                navpanes: 0,
            };
            
            PDFObject.embed(file, $node, options);
            
        } else {
            $($node).append('<p>Tämä selain ei tue pdf -tiedostoja. Lataa tiedosto katsellaksesi sitä:</p> <a download class="download-pdf" href="'+file+'">Lataa PDF</a>')
        }
     }

});